import React from 'react'
import SectionLabel from '../SectionLabel/SectionLabel'
import Styles from '../Content/Content.css'
import simon from '../../assets/Simon.jpg'

const Where = () => {
  return (
    <section className="pt-10 md:pt-20 where-section">
      <div className="container">
        <SectionLabel
          heading={'Where We Play'}
          body={
            'Find us on campus in research labs, historic buildings, and an impressive Honors Village.'
          }
          styles={'font-color-arizona-blue'}
        />
        <div className="flex max-md:flex-col-reverse pt-2">
          <div className="basis-1/2">
            <div className="where-banner font-bold text-white pl-10 pt-6 pb-6 mt-16 relative">
              <p>
                Take a look around the Honors Village, your central hub for the Franke Honors
                community.
              </p>
            </div>
            <div>
              <ul className="perks pl-8 md:pl-12 md:pt-12  font-color-arizona-blue">
                <li>Contemporary living spaces</li>
                <li>On-site faculty and staff support</li>
                <li> ‘85 North (all-you-care-to-eat dining hall)</li>
                <li> State-of-the-art classrooms</li>
                <li> Inspiring study spots</li>
                <li>NorthREC recreation facility (located directly nearby)</li>
              </ul>
            </div>
          </div>
          <div className="basis-1/2">
            <div className="video-container mt-6">
              <iframe
                src="https://www.youtube.com/embed/2gOh1UXOr9o?si=2gpKvsuYPdBGfFPW"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen
              ></iframe>
            </div>
          </div>
        </div>
        <div className="md:flex pt-16 who-quote simon-quote font-color-arizona-blue">
          <div className="max-md:hidden">
            <img src={simon} width="346" />
          </div>
          <div className="flex flex-col justify-center font-semibold md:max-w-[430px]">
            <p className="italic">
              “The biggest benefit for me is having access to the Honors Village. It’s really nice
              having everything you need in one place.”
            </p>
            <p className="pt-2 inline">— Simon, Chemical Engineering</p>
          </div>
          <div className="sig-image2 max-md:block md:hidden">
            <img src={simon} width="235" />
          </div>
        </div>
      </div>
    </section>
  )
}

export default Where
